// extracted by mini-css-extract-plugin
export default {"text":"Refund_text__yaOdt"};